import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";

function MeetingCreatesessionmodal({
  show,
  handleClose,
  title = "Create Meeting Chat Topic",
  button = "Create",
  apiUrl,
  meetingId,
  loginUserID,
  apiToken,
  meeting_summaries_id,
  sideConvoList = [], // <-- Add this prop for parent convo list
}) {
  const [sessionName, setSessionName] = useState("");
  const [sessionType, setSessionType] = useState("side");
  const [selectedSideConvo, setSelectedSideConvo] = useState("");
  const [error, setError] = useState("");
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    if (show) {
      setSessionName("");
      setSessionType("side");
      setSelectedSideConvo("");
      setError("");
    }
  }, [show]);

  const meetingContext = `For information, this is the meeting summary:
         Meeting Title: ${meeting_summaries_id?.meeting_title || "N/A"}
        Meeting Date: ${meeting_summaries_id?.meeting_date || "N/A"}
        Overview: ${meeting_summaries_id?.overview || "N/A"}
       Short Summary: ${meeting_summaries_id?.short_summary || "N/A"}
       Gist: ${meeting_summaries_id?.gist || "N/A"}
      Key Points: ${meeting_summaries_id?.shorthand_bullet || "N/A"}
      Bullet Gist: ${meeting_summaries_id?.bullet_gist || "N/A"}
      `;
  // console.log(meetingContext, "Meeting Context");

  const handleSubmit = () => {
    if (!sessionName || !sessionName.trim()) {
      setError("Topic name is required");
      return;
    }
    if (sessionType === "child" && !selectedSideConvo) {
      setError("Please select a parent topic");
      return;
    }

    const payload = {
      session_name: sessionName,
      session_type: "side",
      meeting_id: meetingId,
      user_id: loginUserID,
      message: meetingContext,
      parent_session_id: sessionType === "child" ? selectedSideConvo : null,
    };
    setButtonDisable(true);

    fetch(`${apiUrl}/meeting_new_session_create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const data = await response.json();

        // Check if response is OK (status 200-299)
        if (response.ok) {
          // Success - show success popup
          Swal.fire({
            icon: "success",
            title: "Topic Created!",
            text: `Your topic "${sessionName}" has been created successfully.`,
            timer: 2500,
            showConfirmButton: false,
            background: "var(--background)",
            color: "var(--text)",
            confirmButtonColor: "var(--teal-bg)",
          });
          handleClose();
        } else {
          // API returned error status
          const errorMessage =
            data.detail || data.message || data.error || "An error occurred while creating the topic";
          setError(errorMessage);
          Swal.fire({
            icon: "error",
            title: "Topic Creation Failed",
            text: errorMessage,
            background: "var(--background)",
            color: "var(--text)",
            confirmButtonColor: "var(--teal-bg)",
          });
        }
      })
      .catch((error) => {
        const errorMessage =
          error?.message || "An error occurred while creating the topic";
        setError(errorMessage);
        Swal.fire({
          icon: "error",
          title: "Topic Creation Failed",
          text: errorMessage,
          background: "var(--background)",
          color: "var(--text)",
          confirmButtonColor: "var(--teal-bg)",
        });
      })
      .finally(() => setButtonDisable(false));
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header
        style={{ background: "#000", color: "#fff" }}
        closeButton
        closeVariant="white"
      >
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formSessionName">
          <Form.Label>Topic Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter topic name"
            value={sessionName}
            onChange={(e) => setSessionName(e.target.value)}
            isInvalid={!!error && !sessionName.trim()}
          />
          <Form.Control.Feedback type="invalid">
            {error && !sessionName.trim() ? error : ""}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Label>Topic Type</Form.Label>
          <Form.Control
            as="select"
            value={sessionType}
            onChange={(e) => setSessionType(e.target.value)}
          >
            <option value="side">Topic</option>
            <option value="child">Subtopic</option>
          </Form.Control>
        </Form.Group>
        {sessionType === "child" && (
          <Form.Group className="mt-2">
            <Form.Label>Parent Topic List</Form.Label>
            <Form.Control
              as="select"
              value={selectedSideConvo}
              onChange={(e) => setSelectedSideConvo(e.target.value)}
              isInvalid={
                !!error && sessionType === "child" && !selectedSideConvo
              }
            >
              <option value="">Select a parent topic</option>
              {sideConvoList.map((convo) => (
                <option key={convo.id} value={convo.id}>
                  {convo.name}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {error && sessionType === "child" && !selectedSideConvo
                ? error
                : ""}
            </Form.Control.Feedback>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          disabled={buttonDisable}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button variant="dark" disabled={buttonDisable} onClick={handleSubmit}>
          {buttonDisable ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Creating...
            </>
          ) : (
            button
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MeetingCreatesessionmodal;
